import { render, staticRenderFns } from "./NewsDescriptionPage.vue?vue&type=template&id=49d0d18a&scoped=true&"
import script from "./NewsDescriptionPage.vue?vue&type=script&lang=js&"
export * from "./NewsDescriptionPage.vue?vue&type=script&lang=js&"
import style0 from "./NewsDescriptionPage.vue?vue&type=style&index=0&id=49d0d18a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d0d18a",
  null
  
)

export default component.exports